$(document).ready(function () {
  // Check if any sliders exist
  if ($('.image-owl-slider').length > 0) { 
    $('.image-owl-slider').each(function () { 
      const imagesPerSlide = $(this).data('images-per-slide') || 1; // Default to 1 if not set
      const mImagesPerSlide = $(this).data('mobile-images-per-slide') || 1; // Default to 1 if not set

      // Initialize Owl Carousel
      $(this).owlCarousel({
        items: imagesPerSlide,
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        responsive: {
          0: {
            items: mImagesPerSlide
          },
          600: {
            items: mImagesPerSlide
          },
          1000: {
            items: imagesPerSlide
          }
        }
      });
    });
  } 
  if ($('.lp_image_slider').length > 0) { 
    $('.lp_image_slider').each(function () { 
      const imagesPerSlide = $(this).data('images-per-slide') || 1; // Default to 1 if not set
      const mImagesPerSlide = $(this).data('mobile-images-per-slide') || 1; // Default to 1 if not set

      // Initialize Owl Carousel
      $(this).owlCarousel({
        items: imagesPerSlide,
        loop: true,
        margin: 10,
        nav: false,
        items: 1, 
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000 
      });
    });
  }  




if ($('.feature_section_area').length > 0) {
    var hs_container = $(".feature_section_area");
    var scroll_items = $(".featured_h_slides");
    var ticking = false;

    $(window).on('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var scroll_items_width = scroll_items.outerWidth();
          hs_container.css('height', scroll_items_width + 500);
          var container_offset_top = hs_container.offset().top + 500;
          var wtop = $(window).scrollTop();
          var offsetD = container_offset_top - wtop;
          scroll_items.css('transform', 'translateX(' + offsetD + 'px)');
          ticking = false;
        });
        ticking = true;
      }
    });
}


  
  /*
if ($('.featured_slides').length > 0) {
    $('.featured_slides').each(function () {
        var owlFeatured = $(this);
        owlFeatured.owlCarousel({
            loop: false,
            margin: 10,
            nav: false,
            smartSpeed: 2500,
            center: true,
            items: 1.2,
            touchDrag: true,
            dots: false,
            autoplay: false,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1.2
                },
                1000: {
                    items: 1.2,
                    margin: 40
                }
            }
        });

        var owlStage = owlFeatured.find('.owl-stage'); 
        var startX = 0, scrollLeft = 0, isDragging = false;

        owlStage.on('mousedown touchstart', function (e) {
            isDragging = true;
            startX = e.pageX || e.originalEvent.touches[0].pageX;
            scrollLeft = owlStage.position().left;
            e.preventDefault();
        });

        $(document).on('mousemove touchmove', function (e) {
            if (!isDragging) return;
            var x = e.pageX || e.originalEvent.touches[0].pageX;
            var moveX = x - startX;

            // Move the stage manually
            owlStage.css('transform', 'translateX(' + (scrollLeft + moveX) + 'px)');
        });

        $(document).on('mouseup touchend', function () {
            isDragging = false;
        });

    }); 

}
  */
/*

  
  if ($('.featured_slides').length > 0) { 
    $('.featured_slides').each(function () {   
      $(this).owlCarousel({ 
        loop: true,
        margin: 10,
        nav: false,
        items: 1.2, 
        dots: false,
        autoplay: false ,         
        responsive: {
            0: {
                items: 1 
            },
            600: {
                items: 1.2 
            },
            1000: {
                items: 1.3 ,
                margin: 40
            },
            1500: {
                items: 1.8 ,
                margin: 70
            }
        }
      });
    });
  } 

  */
});